<template>
    <el-form :model="form"
             ref="form"
             size="mini"
             :rules="$options.rules"
             hide-required-asterisk
             :show-message="false"
             @validate="$emit('validate')">
        <div class="col-form-items">
            <el-form-item class="form-item" prop="moduleNormal" :label-width="labelWidth.col1">
                <span slot="label">Module<sub>n</sub></span>
                <el-input v-model="form.moduleNormal" class="form-field" @change="emitChange">
                    <template slot="suffix">mm</template>
                </el-input>
            </el-form-item>
            <el-form-item class="form-item" prop="pressureAngleNormal" :label-width="labelWidth.col2">
                <span slot="label">Pressure angle<sub>n</sub></span>
                <el-input v-model="form.pressureAngleNormal" class="form-field" @change="emitChange">
                    <template slot="suffix">{{units.angle}}</template>
                </el-input>
            </el-form-item>
        </div>
        <div class="col-form-items">
            <el-form-item class="form-item" label="Addendum coeff." prop="addendumCoefficient" :label-width="labelWidth.col1">
                <el-input v-model="form.addendumCoefficient" class="form-field" @change="emitChange"/>
            </el-form-item>
            <el-form-item class="form-item" label="Dedendum coeff." prop="dedendumCoefficient" :label-width="labelWidth.col2">
                <el-input v-model="form.dedendumCoefficient" class="form-field" @change="emitChange"/>
            </el-form-item>
        </div>
        <div class="col-form-items">
            <el-form-item class="form-item" prop="protuberanceSize" :label-width="labelWidth.col1">
                <span slot="label">Protuberance size<sub>n</sub></span>
                <el-input v-model="form.protuberanceSize" class="form-field" @change="emitChange">
                    <template slot="suffix">mm</template>
                </el-input>
            </el-form-item>
            <el-form-item class="form-item" prop="protuberanceAngle" :label-width="labelWidth.col2">
                <span slot="label">Protuberance ang<sub>n</sub></span>
                <el-input v-model="form.protuberanceAngle" class="form-field" @change="emitChange">
                    <template slot="suffix">{{units.angle}}</template>
                </el-input>
            </el-form-item>
        </div>
        <div class="col-form-items">
            <el-form-item class="form-item" label="Tip radius coeff." prop="tipRadiusCoefficient" :label-width="labelWidth.col1">
                <el-input v-model="form.tipRadiusCoefficient" class="form-field" @change="emitChange" :disabled="form.tipRadiusMax"/>
            </el-form-item>
            <el-form-item class="form-item" label="Max tip radius" prop="tipRadiusMax" :label-width="labelWidth.col2">
                <el-checkbox v-model="form.tipRadiusMax" class="form-field" @change="emitChangeTipMax"/>
            </el-form-item>
        </div>
    </el-form>
</template>

<script>
  import { rules } from "../../assets/js/validators";

  export default {
    name: "FormHobGeom",
    props: {
      form: Object,
      labelWidth: Object,
      units: Object,
    },
    rules: {
      addendumCoefficient: rules.requiredPositiveNumber,
      dedendumCoefficient: rules.requiredPositiveNumber,
      moduleNormal: rules.requiredPositiveNumber,
      pressureAngleNormal: rules.requiredPositiveNumber,
      protuberanceAngle: rules.requiredZeroPositiveNumber,
      protuberanceSize: rules.requiredZeroPositiveNumber,
      tipRadiusCoefficient: rules.requiredZeroPositiveNumber,
    },
    methods: {
      validate() {
        return this.$refs.form.validate();
      },
      emitChange() {
        // @change event triggers only if the input has changed when the box loses focus or the Enter key is pressed

        this.$refs.form.validate((valid) => {
          this.$emit('change', valid);
        });
      },
      emitChangeTipMax(val) {
        // arg: boolean to indicate if max tool tip radius is checked.

        this.$refs.form.validate((valid) => {
          this.$emit('change-tip-max', valid, val)
        });
      },
    },
  }
</script>

<style scoped src="../../assets/css/form.css"/>
